// extracted by mini-css-extract-plugin
module.exports = {"monthCards":"styles_monthCards__2oF8o","monthName":"styles_monthName__EFd5z"};